import React, { useEffect, forwardRef, useImperativeHandle } from 'react';
import { Form } from 'antd';
import { useFormAccess } from '../../hooks';

export const withAntdForm = (formName, ThisFormComponent) => {
  if (!formName || !ThisFormComponent) {
    throw new Error(`name and form  component need to be present`);
  }

  const WrapperComponent = (props) => {
    // on un-mount always reset
    useEffect(() => {
      // eslint-disable-next-line
      props.form.resetFields();
    }, []);

    return <ThisFormComponent {...props} />;
  };

  // TODO: Remove this when Ant supports function based component
  class FormComponent extends React.PureComponent {
    render() {
      return <WrapperComponent {...this.props} />;
    }
  }

  const AntdForm = Form.create({
    name: formName,
  })(FormComponent);

  const FormComponentHigherWrapper = forwardRef((props, ref) => {
    const [thisRef, { getFields }] = useFormAccess(null);

    useImperativeHandle(ref, () => ({
      getFields,
    }));

    return <AntdForm ref={thisRef} {...props} />;
  });

  return FormComponentHigherWrapper;
};
